module.exports = __webpack_public_path__ + "img/fondo.82ba78a3.jpg";